import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from './icons/CheckIcon';
import { DocIcon } from './icons/DocIcon';
import { FileSearchOutlined } from '@ant-design/icons';
import { SectionIcon } from './SectionIcon';

// A parsed document with no service records in it
export const EmptyReport = ({ empty }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section className="card empty" aria-labelledby="empty-title">
            <div className="empty-ic" aria-hidden="true">
                <DocIcon color="#B8165F" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 720 }}>
                <h2 id="empty-title" className="h2">
                    <SectionIcon icon={FileSearchOutlined} />
                    {empty.title}
                </h2>
                <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--tokens-text-secondary)' }}>
                    {empty.text}
                </p>
            </div>
            {empty.files.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <span className="eyebrow">{t('empty.filesReceived')}</span>
                    <div className="filelist">
                        {empty.files.map(name => (
                            <span className="fileok" key={name}>
                                <CheckIcon />
                                {name}
                            </span>
                        ))}
                    </div>
                </div>
            )}
            {empty.actions && (empty.onUpload || empty.originalUrl) && (
                <div className="actions noprint">
                    {empty.onUpload && (
                        <button type="button" className="btn btn-primary" onClick={empty.onUpload}>
                            {t('empty.upload')}
                        </button>
                    )}
                    {empty.originalUrl && (
                        <a className="textlink" href={empty.originalUrl} target="_blank" rel="noreferrer">
                            {t('empty.openOriginal')}
                        </a>
                    )}
                </div>
            )}
        </section>
    );
};
